import styles from '../index.module.scss';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useSignUpService } from '../../../services/signUpService';

const SignUpWithNameLink = () => {
  const { state } = useSignUpService();

  if (state.invite?.forceVerifiedUsers) {
    return null;
  }

  return (
    <div className="leading-5 text-sm font-normal text-neutrals-n-400 text-center flex items-center flex-wrap justify-center">
      Don’t have a work Email?
      <Button
        variant="text"
        className={styles.link}
        onClick={() => {
          state.setSignUpMethod('username');
        }}
      >
        Sign up with a username
      </Button>
    </div>
  );
};
export default observer(SignUpWithNameLink);
